import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    NO_CHANGE,
    SET,
    RESET
} from 'one-state-subject/src/types';

import {
    setAction, reinitAction
} from 'one-state-patient-pharmacy/src/action';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';
import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';

export const enum Types {
    SETPHARMACY = 'one-state-patient-pharmacy/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Function will fetch the data of Pharmacy
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchPharmacyEpic = (context: any) => (
    (action$: any, state$: any) => {
    const errorTime = format(new Date(),'LT');
    const errorDate = format(new Date(),'LL');
    const { server, log, agentId, settings: {
        epicendpoints:{
            getpharmacy,
            apitoken
        },
        uisettings: {
            dashboardapiconfig: {
                getpharmacy : getpharmacyApi
            }
        },
        compatible : { consolidated_api_invocation, contact_center_type },
    }} = context;
    return action$.pipe(
        consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED),
        mergeMap((action: any) => {
        let dataresponse: any = action.payload;
        const getRequest = (datares: any) => {
            if (datares?.id) {
            let headers = new Headers();
            headers.set('Authorization', 'Basic ' + apitoken?.token);
            const data = {
                "PatientID": datares?.id,
            }
            const response = server.post({
                //path: epicendpoints?.getpharmacy + "?patient_id=E5597",
                path: getpharmacy + "?patient_id=" + data.PatientID,
                headers: headers
            })
            .then((responsefound: any) => responsefound)
            .catch((responseresult: any) => {
                log.error(
                    "ccw-gadget,pharmacies-epic",
                    "fetch-Appt-epic", {
                    responseresult
                    }
                );
                let errorbuild: ErrorObject = {
                    source: "Pharmacies",
                    type: "error",
                    status: responseresult?.status,
                    erroritems: responseresult?.errors,
                    error_date: errorDate,
                    error_time: errorTime
                };
                return errorbuild;
            })
                log.debug(
                    "ccw-gadget,pharmacies-epic",
                    "fetch-Appt-epic", {
                    response
                    }
                );
            return from(response)
            } else {
                return from([]);
            }
        }
        if (!getpharmacyApi) return []
        return getRequest(dataresponse).
               pipe(
                map((response: any) => TransformResponse(response, context))).
                pipe(
                    flatMap(response => {
                        const actions:any =[
                            setAction(response.pdata)                            ];
                        if(response.error){
                            actions.push(addAction(response.error));
                            let disp: Disposition = { value: "1003" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                disp.meta00 = agentIdValue;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta01 = dataresponse?.id;
                            disp.meta02 = response?.error?.status;
                            disp.meta03 = response?.error?.erroritems[0]?.error_detail;
                            disp.meta04 = 'client';
                            actions.push(pushToDisposition(disp));
                        } else {
                            let disp: Disposition = { value: "186" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                disp.meta00 = agentIdValue;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta01 = dataresponse?.id;
                            disp.meta02 = '200';
                            disp.meta03 = 'client';
                            actions.push(pushToDisposition(disp));
                        }
                        // clear skeleton for pending bills
                        let skeletonPharmacy: Skeleton = {
                            pharmacies_skeleton: false
                        }
                        actions.push(pushToSkeleton(skeletonPharmacy));
                        return actions;
                    })
                    )
            })
        )
    }
);

export const clearPharmacyEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, patient-pharmacyepic",
            "clear-Pharmacy-epic", {
        });
        return action$.pipe(
            ofType(SET, RESET),
            map(action => reinitAction())
        )

    }
);
